export const FETCH_LABELS = 'FETCH_LABELS'
export const FETCH_LABELS_SUCCESS = 'FETCH_LABELS_SUCCESS'
export const FETCH_LABELS_ERROR = 'FETCH_LABELS_ERROR'

export const FETCH_STATIC_PAGE = 'FETCH_STATIC_PAGE'

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
